import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThumbsUpEmpty = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.58333 16H5.75C4.64543 16 3.75 15.1046 3.75 14V10C3.75 8.89543 4.64543 8 5.75 8H8.2524C8.43135 8 8.59666 7.90437 8.68586 7.74924L11.2195 3.34295C11.335 3.14197 11.5766 3.04513 11.7944 3.12462C14.5951 4.14683 13.4713 6.1518 12.8967 7.87013C12.8752 7.93437 12.9234 8 12.9911 8H14.3227C15.7074 8 16.6732 9.37326 16.2048 10.6764L15.0052 14.0146C14.5771 15.2057 13.4476 16 12.1819 16H7.58333ZM7.58333 16V8",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgThumbsUpEmpty;
